import styled from "styled-components";

const SlaAdminTableRowColumn = styled.td`
    padding: 0.6rem !important;
    vertical-align: middle;
    width: ${({ width }) => width}%;
`;

export default SlaAdminTableRowColumn;